import axiosInstance from "./axiosInstance";

const salesStatsService = {
  fetchDailyPatientStats: async () => {
    try {
      const response = await axiosInstance.get(
        "/sales/daily-pateint-stats"
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchDailyMedicineStats: async () => {
    try {
      const response = await axiosInstance.get(
        "/sales/daily-medicine-stats"
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchDailyServicesStats: async () => {
    try {
      const response = await axiosInstance.get(
        "/sales/daily-services-stats"
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchDailyPharmacyStats: async () => {
    try {
      const response = await axiosInstance.get(
        "/sales/daily-pharmacy-stats"
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default salesStatsService;